import dayjs from "dayjs";
import { ABROAD_BIRTH_PLACE_ID } from "../../../../constants";

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const onSubmit = (setError, mutate, paravoloCode) => {
  // console.log("onSubmit A");
  return async (values, actions) => {
    // console.log("onSubmit A1");
    // console.log(values);
    setError();
    const newDocuments = [];
    let topos_eggrafis = "";

    for (let i = 0; i < values?.uploadedDocuments?.length; i++) {
      if (values?.uploadedDocuments[i]?.new) {
        let filesBase64 = [];
        for (let j = 0; j < values.uploadedDocuments?.[i].files?.length; j++) {
          filesBase64.push({
            filename: values.uploadedDocuments?.[i].files?.[j].name,
            data: await toBase64(values.uploadedDocuments?.[i].files?.[j]),
            contentType: values.uploadedDocuments?.[i].files?.[j].type,
          });
        }
        newDocuments.push({
          ...values.uploadedDocuments?.[i],
          files: filesBase64,
        });
      }
    }
    // console.log("onSubmit B");
    if (values.place_birth_afora.id) {
      // Check if birth place !== ABROAD_BIRTH_PLACE_ID and put topos_eggrafis =null otherwise puts the value added by the user
      parseInt(values.place_birth_afora.id) !== ABROAD_BIRTH_PLACE_ID
        ? (topos_eggrafis = "")
        : (topos_eggrafis = values.topos_eggrafis_dimotologiou_ellada);
    } else {
      values.place_birth_afora !== ABROAD_BIRTH_PLACE_ID
        ? (topos_eggrafis = "")
        : (topos_eggrafis = values.topos_eggrafis_dimotologiou_ellada);
    }
    // console.log("onSubmit C");
    if (values.afm_afora === values.afm_ait) {
      // console.log("onSubmit D1");
      mutate({

        // application
        id: values.id,
        port_authority_id: values.port_authority_id,
        appl_kind_id: values.appl_kind_id,
        appl_dt: dayjs(values.appl_dt, "DD/MM/YYYY").format("YYYY-MM-DD"),
        comments: values.comments,
        reg_num: values.reg_num,

        // applicant
        lname_ait: values.lname_afora,
        fname_ait: values.fname_afora,
        afm_ait: values.afm_afora,
        ind_nr_ait: values.ind_nr_afora,
        fath_lname_ait: values.fath_lname_afora,
        fath_fname_ait: values.fath_fname_afora,
        address_ait: values.address_afora,
        address_nr_ait: values.address_nr_afora,
        tk_ait: values.tk_afora,
        tel_ait: values.tel_afora,
        mobile_ait: values.mobile_afora,
        email_ait: values.email_afora,
        amka_ait: values.amka_afora,
        meth_ait: values.meth_ait,

        // person concerned with the application
        lname_afora: values.lname_afora,
        fname_afora: values.fname_afora,
        afm_afora: values.afm_afora,
        ind_nr_afora: values.ind_nr_afora,
        fath_lname_afora: values.fath_lname_afora,
        fath_fname_afora: values.fath_fname_afora,
        moth_lname_afora: values.moth_lname_afora,
        moth_fname_afora: values.moth_fname_afora,
        dt_birth_afora:
          dayjs(values.dt_birth_afora).format("YYYY-MM-DD") || null,
        place_birth_afora:
          values.place_birth_afora?.id || values.place_birth_afora || null,
        dimos_diamonis_afora:
          values.dimos_diamonis_afora?.id ||
          values.dimos_diamonis_afora ||
          null,
        address_afora: values.address_afora,
        address_nr_afora: values.address_nr_afora,
        tk_afora: values.tk_afora,
        tel_afora: values.tel_afora,
        mobile_afora: values.mobile_afora,
        email_afora: values.email_afora,
        status: values.status,
        amka_afora: values.amka_afora,
        meth_afora: values.meth_afora,
        oldStatus: values.oldStatus,
        rndv_from: values.rndv_from,
        rndv_to: values.rndv_to,
        pickup_place_id: values.pickup_place?.id || values.pickup_place_id,
        documents: JSON.stringify(newDocuments),
        sintaksiouxos_afora: values.sintaksiouxos_afora?.id || null,
        epipedo_ekpaideusis_afora: values.epipedo_ekpaideusis_afora?.id,
        topos_eggrafis_dimotologiou_ellada: topos_eggrafis,
        gender_afora: values.gender_afora?.id,
        nationality_afora: values.nationality_afora,
        didactic_year_id: values.didactict_year?.id || null,
        reason_for_copy_nautical_issue: !isNaN(
          parseInt(values.reason_for_copy_nautical_issue)
        )
          ? parseInt(values.reason_for_copy_nautical_issue)
          : null,
        birth_country_id: values?.birth_country?.id,
        birth_city_not_greece: values?.birth_city_not_greece || null,
        criminal_record_requestId:
          values?.place_birth_afora?.criminal_record_requestId,
        ...paravoloCode,
      });
    } else {
      // console.log("onSubmit D2");
      mutate({

        // application
        id: values.id,
        port_authority_id: values.port_authority_id,
        appl_kind_id: values.appl_kind_id,
        appl_dt: dayjs(values.appl_dt, "DD/MM/YYYY").format("YYYY-MM-DD"),
        reg_num: values.reg_num,
        comments: values.comments,

        // applicant
        lname_ait: values.lname_ait,
        fname_ait: values.fname_ait,
        afm_ait: values.afm_ait,
        ind_nr_ait: values.ind_nr_ait,
        fath_lname_ait: values.fath_lname_ait,
        fath_fname_ait: values.fath_fname_ait,
        address_ait: values.address_ait,
        address_nr_ait: values.address_nr_ait,
        tk_ait: values.tk_ait,
        tel_ait: values.tel_ait,
        mobile_ait: values.mobile_ait,
        email_ait: values.email_ait,
        amka_ait: values.amka_ait,
        meth_ait: values.amka_ait,

        // person concerned with the application
        lname_afora: values.lname_afora,
        fname_afora: values.fname_afora,
        afm_afora: values.afm_afora,
        ind_nr_afora: values.ind_nr_afora,
        fath_lname_afora: values.fath_lname_afora,
        fath_fname_afora: values.fath_fname_afora,
        moth_lname_afora: values.moth_lname_afora,
        moth_fname_afora: values.moth_fname_afora,
        dt_birth_afora:
          dayjs(values.dt_birth_afora).format("YYYY-MM-DD") || null,
        place_birth_afora:
          values.place_birth_afora?.id || values.place_birth_afora || null,
        dimos_diamonis_afora:
          values.dimos_diamonis_afora?.id ||
          values.dimos_diamonis_afora ||
          null,
        address_afora: values.address_afora,
        rndv_from: values.rndv_from,
        rndv_to: values.rndv_to,
        address_nr_afora: values.address_nr_afora,
        tk_afora: values.tk_afora,
        tel_afora: values.tel_afora,
        mobile_afora: values.mobile_afora,
        email_afora: values.email_afora,
        amka_afora: values.amka_afora,
        meth_afora: values.amka_afora,
        status: values.status,
        oldStatus: values.oldStatus,
        pickup_place_id: values.pickup_place?.id || values.pickup_place_id,
        documents: JSON.stringify(newDocuments),
        sintaksiouxos_afora: values?.sintaksiouxos_afora,
        epipedo_ekpaideusis_afora: values.epipedo_ekpaideusis_afora?.id,
        topos_eggrafis_dimotologiou_ellada: topos_eggrafis,
        gender_afora: values.gender_afora?.id,
        nationality_afora: values.nationality_afora,
        didactic_year_id: values.didactict_year?.id || null,
        reason_for_copy_nautical_issue: !isNaN(
          parseInt(values.reason_for_copy_nautical_issue)
        )
          ? parseInt(values.reason_for_copy_nautical_issue)
          : null,
        birth_country_id: values?.birth_country?.id,
        birth_city_not_greece: values?.birth_city_not_greece || null,
        criminal_record_requestId:
          values?.place_birth_afora?.criminal_record_requestId,
        ...paravoloCode,
      });
    }

    actions.setSubmitting(false);
  };
};

export default onSubmit;
